module.exports = "<th>\n\t<span ng-if=\"::!categoryIs('commercial')\">Этажей в доме</span>\n\t<span ng-if=\"::categoryIs('commercial')\">Этажей в здании</span>\n</th>\n<td>\n\t<cian-serp-range source=\"filter.floorn\"></cian-serp-range>\n</td>\n"


//////////////////
// WEBPACK FOOTER
// ./src/components/advanced-browser/templates/sections/floorn.html
// module id = 343
// module chunks = 0